<template>
  <div id="header">
    <div class="header">
      <div class="header_left">
        <img src="http://open.beijing.gov.cn/common/images/icon/opbj.png">
        <div>{{ProjectName}}</div>
      </div>
      <div class="header_main">
        <el-menu :default-active="this.$route.path" class="el-menu-demo" mode="horizontal" router
          background-color="#BD1A2D" text-color="white" :unique-opened="true">
          <template v-for="item in RouteList">
            <!-- 一级 -->
            <el-menu-item v-if="item.children.length <= 0" :index="item.link" :key="item.id">
              <template v-slot:title>{{ item.name }}</template>
            </el-menu-item>
            <!-- 二级 -->
            <el-submenu v-if="item.children.length > 0" :index="item.link" :key="item.id">
              <template v-slot:title>{{ item.name }}</template>
              <template v-if="item.children && item.children.length > 0">
                <el-menu-item class="liClass" :index="item.link + '/' + el.link"
                  v-for="el in item.children" :key="el.id">
                  {{ el.name }}
                </el-menu-item>
              </template>
            </el-submenu>
          </template>
        </el-menu>
      </div>
      <div class="header_right">
        <el-avatar><i class="el-icon-user-solid"></i></el-avatar>
        <el-dropdown trigger="click">
          <div class="header_right_text">{{UserName}}<div class="el-icon-caret-bottom"></div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-user-solid">
              <span @click="handleClick('Back')">用户中心</span>
            </el-dropdown-item>
            <el-dropdown-item icon="el-icon-s-promotion">
              <span @click="handleClick('signOut')">安全退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  components: {},
  props: {},
  data () {
    return {
      UserName: JSON.parse(sessionStorage.getItem('user')).account,
      ProjectName: process.env.VUE_APP_Project_Name,
      RouteList: []
    }
  },
  methods: {
    // 安全退出
    handleClick (type) {
      if (type === 'signOut') {
        this.$http.post('/ucenter/user/front/logout').then(() => {
          window.location.href = '/web/userCenter'
        })
      } else {
        window.location.href = '/web/userCenter#/Usercenter'
      }
    },
    renderCrumbs () {
      this.RouteList = this.$UserCenterdRouter.list()
    }
  },
  created () {
    this.renderCrumbs()
  },
  watch: {},
  mounted () { }
}
</script>
<style scoped>
#header {
  width: 100%;
  min-width: 1200px;
  height: 61px;
  background: #bd1a2d;
  margin-bottom: 20px;
}
.header {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.header_left {
  height: 100%;
  /* flex: 1.5; */
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  font-size: 20px;
  color: #fff;
  font-weight: bold;
  margin-right: 20px;
}
.header_left img {
  height: 60px;
  width: 60px;
  margin-right: 20px;
}
.header_main {
  flex: 5;
}
.el-menu--horizontal {
  background: #bd1a2d;
  border: none;
}
.header_right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  color: #fff;
}
.header_right img {
  height: 30px;
  width: 30px;
}
.header_right_text {
  cursor: pointer;
  color: #fff;
  margin-right: 8px;
  font-size: 14px;
}
::v-deep .el-submenu .el-submenu__title i {
  color: white !important;
}
::v-deep .is-active .el-submenu__title {
  border-bottom-color: white !important;
  color: white !important;
}
::v-deep .el-submenu .el-submenu__title:hover {
  background: #ae1529 !important;
}
::v-deep .el-submenu__title:hover,
.liClasss:hover,
.el-menu-item:hover {
  background: #ae1529 !important;
}
::v-deep .el-menu--horizontal .el-menu .el-menu-item .is-active {
  color: white !important;
  border-bottom: none;
}
::v-deep .el-menu--horizontal .el-menu .el-menu-item.is-active,
.el-menu--horizontal .el-menu .el-submenu.is-active > .el-submenu__title {
}
::v-deep .el-menu--horizontal > .el-menu-item.is-active {
  border-color: white !important;
}
</style>
